import Hero from "@/components/sections/Hero";
import TrustedBrands from "@/components/sections/TrustedBrands";
import Services from "@/components/sections/Services";
import BeforeAfter from "@/components/sections/BeforeAfter";
import CaseStudies from "@/components/sections/CaseStudies";
import WhyChoose from "@/components/sections/WhyChoose";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustedBrands />
      <Services />
      <BeforeAfter />
      <CaseStudies />
      <WhyChoose />
      <Process />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
